import React from 'react';

const awards = [
  { icon: '🏆', title: 'INC 500 | Rank #213', year: '2008', desc: 'Recognized among the 500 fastest-growing private companies in America.' },
  { icon: '🏅', title: 'ISO 9001:2000 Certification', year: '2005', desc: 'International quality management system certification.' },
  { icon: '🏛️', title: 'GSA Contract Award', year: '2006', desc: 'Awarded General Services Administration contract for US government services.' },
  { icon: '⭐', title: 'CMMI Level 5 (In Progress)', year: '2024', desc: 'Capability Maturity Model Integration — highest level of process maturity.' },
  { icon: '🌟', title: 'Best IT Company Award', year: '2015', desc: 'Recognized for excellence in IT services and customer satisfaction.' },
  { icon: '🎖️', title: 'Top 10 Offshore Company', year: '2012', desc: 'Ranked among top offshore IT service providers globally.' },
];

const Awards = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Awards & Recognition</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>Our achievements over the years</p>
      </div>
    </section>

    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="row g-4">
          {awards.map((a, i) => (
            <div key={i} className="col-12 col-md-6 col-lg-4">
              <div className="card border-0 shadow-sm h-100 p-4">
                <div className="d-flex align-items-center gap-3 mb-3">
                  <div style={{ fontSize: 40 }}>{a.icon}</div>
                  <div>
                    <h6 className="fw-bold mb-0">{a.title}</h6>
                    <span className="badge bg-primary">{a.year}</span>
                  </div>
                </div>
                <p className="text-muted small mb-0">{a.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default Awards;
